import {useEffect} from "react";

export default function usePageResize(events, fn) {
    useEffect(() => {
        if (!events) return;
        events.addEventListener('pageResize', fn);
        return () => events.removeEventListener('pageResize', fn);
    }, [events]);
}
